import request from "@/utils/request.js";
/**
 * token和手机号修改密码
 * @param params
 * @returns {AxiosPromise}
 */
export function forgetPasswordUpdatePassword(params) {
  return request({
    url: "/userService/api/app/userNurse/forgetPasswordUpdatePassword",
    method: "post",
    data: params
  });
}

/**
 * 登录后 - 设定密码;
 * @param password
 * @param token
 * @returns {AxiosPromise}
 */
export function updatePassword(password, token) {
  return request({
    token: token,
    url: "/userService/api/app/user/nurse/login/updatePassword",
    method: "post",
    data: { password }
  });
}
